﻿import { defineComponent } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "FastLink",

    props: {
        webSite: {
            type: String,
            required: true,
        },
    },
    components: {},
    setup() {
        return {};
    },
    template: html`
        <div class="footer_fastlink">
            <a href="/Destination/1">日本</a>
            <a href="/Destination/2">韓國</a>
            <a href="/Destination/5">遊輪</a>
            <a href="/Destination/13">歐洲</a>
            <a href="/Destination/12">美加紐澳</a>
            <a href="/Destination/14">古文明</a>
            <a href="/Destination/18">東南亞</a>
            <a href="/Destination/9">海島</a>
            <a href="/Destination/4">中國</a>
            <a href="/Destination/19">台灣</a>
        </div>
    `,
});
